import moment from 'moment';

export const getIsHalf = (disabledDates, calendarDay) => {
  const { isAvailableForCheckOut, isAvailableForCheckIn } =
    disabledDates?.find(({ date }) =>
      moment(calendarDay).isSame(date, 'day')
    ) || {};

  return {
    disableLeft: !isAvailableForCheckOut && isAvailableForCheckIn,
    disableRight: isAvailableForCheckOut && !isAvailableForCheckIn
  };
};
